import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { WishlistProvider } from "./context/WishlistContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Category from "./pages/Category";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import Login from "./pages/Login";
import InfoPage from "./pages/InfoPage";
import Contact from "./pages/Contact";
import Account from "./pages/Account";
import Donate from "./pages/Donate";
import ScrollToTop from "./components/ScrollToTop";
import AuthCallback from "./components/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedAdmin from "./pages/admin/ProtectedAdmin";

const StoreLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
      <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
      <Route path="/shop/:categoryId" element={<StoreLayout><Category /></StoreLayout>} />
      <Route path="/product/:productId" element={<StoreLayout><ProductDetail /></StoreLayout>} />
      <Route path="/cart" element={<StoreLayout><CartPage /></StoreLayout>} />
      <Route path="/login" element={<StoreLayout><Login /></StoreLayout>} />
      <Route path="/info/:slug" element={<StoreLayout><InfoPage /></StoreLayout>} />
      <Route path="/contact" element={<StoreLayout><Contact /></StoreLayout>} />
      <Route path="/account" element={<StoreLayout><Account /></StoreLayout>} />
      <Route path="/donate" element={<StoreLayout><Donate /></StoreLayout>} />
      <Route path="/payment/success" element={<StoreLayout><PaymentSuccess /></StoreLayout>} />
      <Route path="/payment/cancel" element={<StoreLayout><PaymentCancel /></StoreLayout>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <WishlistProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <AppRouter />
              <Toaster />
            </BrowserRouter>
          </CartProvider>
        </WishlistProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
